<template>
    <div :value="model"><slot/></div>
</template>

<script>
    export default {
      props:{
        model:Array,
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/checkBoxGroup.vue